import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPracticeId } from "../config/practice";
import { getSummary, INTERP_PRIVILEGE } from "./interpReviewApi";

/*
 * The Tasks page's entry into Interpretation Review: a chip with the signed-in reviewer's pending count
 * (echo drafts without a saved decision; calibration is not counted, owner 10-26). Self-contained: it reads only
 * the Redux privileges and its own v2 summary call, so it changes nothing else on the Tasks page. Rendered only
 * for a 9928 user holding the "Interpretation Review" privilege; any failure renders nothing.
 */
export const INTERP_PRACTICE = "9928";

const InterpReviewTasksLink = () => {
  const navigate = useNavigate();
  const privileges = useSelector((state) => state.userPrivileges?.privileges);
  const allowed =
    String(getPracticeId()) === INTERP_PRACTICE && Array.isArray(privileges) && privileges.includes(INTERP_PRIVILEGE);
  const [pending, setPending] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!allowed) return undefined;
    let live = true;
    getSummary()
      // Echo drafts only (owner 10-26: calibration skipped): studies without a saved decision.
      .then((r) => live && setPending(Math.max(0, (Number(r?.echo?.total) || 0) - (Number(r?.echo?.submitted) || 0))))
      .catch(() => live && setFailed(true));
    return () => {
      live = false;
    };
  }, [allowed]);

  if (!allowed || failed) return null;
  return (
    <button type="button" data-testid="interp-review-link" onClick={() => navigate("/interp-review")}
      title="Interpretation Review: blinded calibration and AI echo drafts (not filed to chart)"
      className="flex items-center gap-2 rounded-full border border-[#e8ecf3] bg-white px-4 py-2 font-inter text-[14px] font-medium text-[#1d2951] hover:bg-[#f2f6fc] hover:border-[#d8dfec]">
      Interpretation Review
      {pending > 0 && (
        <span data-testid="interp-review-pending"
          className="min-w-[22px] rounded-full bg-[#1d3f8f] px-1.5 py-0.5 text-center text-[12px] font-semibold text-white">
          {pending}
        </span>
      )}
    </button>
  );
};

export default InterpReviewTasksLink;
